import clsx from 'clsx';
// mantine
import { Divider, LoadingOverlay, ScrollArea, Title } from '@mantine/core';
// components
import { CopyButton } from '@newo/ui-kit';
import { IConversationsUserPersona } from '@newo/api/gateway';
import Actors from '@/pages/Conversations/components/PersonaDetails/components/Actors';
import Attributes from '@/pages/Conversations/components/PersonaDetails/components/Attributes';
// utils
import { usePersonaDetailsQuery } from '@/pages/Conversations/components/PersonaDetails/PersonaDetails.queries.ts';

interface PersonaDetailsProps {
    className?: string;
    persona: IConversationsUserPersona;
}

const PersonaDetails = ({ className, persona }: PersonaDetailsProps) => {
    const { actors, attributes, isLoading, isSuccess } = usePersonaDetailsQuery(
        persona.id
    );
    return (
        <div className={clsx('h-full overflow-hidden', className)}>
            <LoadingOverlay visible={isLoading} />
            <ScrollArea h="100%" scrollbars="y" type="hover">
                <Title className="pt-5 px-5 break-all" order={3}>
                    {persona.name}
                </Title>
                <div className="flex items-center gap-2 text-xs text-gray-6 pl-6">
                    Id: {persona.id}
                    <CopyButton value={persona.id} />
                </div>
                {isSuccess ? (
                    <>
                        <Actors actors={actors} isSuccess={isSuccess} />
                        <Divider />
                        <Attributes
                            attributes={attributes}
                            isSuccess={isSuccess}
                        />
                    </>
                ) : undefined}
            </ScrollArea>
        </div>
    );
};

export default PersonaDetails;
